import { createI18n } from 'vue-i18n';
import en from '@/TranslatorJson/en.json'
import spanish from '@/TranslatorJson/spanish.json'

function localmeassge() {
    const locales = [{ en: en }, { spanish: spanish }]
    const message = {}
    locales.forEach(lang => {
        const key = Object.keys(lang)
        message[key]=lang[key]
    })
    return message
}
export default createI18n({
    legacy: false,
    locale: localStorage.getItem("Language"),
    fallbackLocale: localStorage.getItem("Language"),
    messages:localmeassge()
})